import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

import ButtonsGroup from '../ButtonsGroup';

const {
  StyledButton,
  propTypes: ButtonsGroupPropTypes,
  defaultProps: ButtonsGroupDefaultProps,
} = ButtonsGroup;

class ToggleButtonsGroup extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      values: props.values,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleRef = this.handleRef.bind(this);
  }

  UNSAFE_componentWillReceiveProps({ values }) {
    const { values: prevValues } = this.state;
    if (!isEqual(values, prevValues)) {
      this.setState({ values });
    }
  }

  handleChange(event) {
    const { detail } = event;

    let { value: nextValue } = detail;
    const { multiple: isMultiple, onChange } = this.props;

    nextValue = isMultiple ? nextValue : [nextValue.pop()];

    this.setState({
      values: nextValue,
    });

    event.detail.value = nextValue;
    this.el.dispatchEvent(event);
    onChange(event);
  }

  handleRef(component) {
    this.el = ReactDOM.findDOMNode(component);
  }

  render() {
    const { children, ...props } = this.props;
    const { values } = this.state;

    const key = values ? values.join('') : '';
    return (
      <StyledToggleButtonsGroup
        {...props}
        key={key}
        onChange={this.handleChange}
        ref={this.handleRef}
        values={values}
      >
        {children}
      </StyledToggleButtonsGroup>
    );
  }
}

ToggleButtonsGroup.propTypes = {
  ...ButtonsGroupPropTypes,
  multiple: PropTypes.bool,
};

ToggleButtonsGroup.defaultProps = {
  ...ButtonsGroupDefaultProps,
  multiple: false,
};

const StyledToggleButtonsGroup = styled(ButtonsGroup)`
  height: 36px;
  display: flex;

  ${StyledButton} {
    border: none;
    height: 100%;
    padding: 0 8px;
    border-radius: 0;
    line-height: normal;
    border-top: solid 1px #007aff;
    border-bottom: solid 1px #007aff;

    :focus {
      z-index: 2; // Outline's view fix.
    }

    &:first-child {
      padding-left: 12px;
      border-left: solid 1px #007aff;
      border-top-left-radius: 36px;
      border-bottom-left-radius: 36px;
    }

    &:last-child {
      padding-right: 12px;
      border-right: solid 1px #007aff;
      border-top-right-radius: 36px;
      border-bottom-right-radius: 36px;
    }

    &[data-checked='true'] {
      border-color: white;
    }
  }

  > ${StyledButton} + ${StyledButton} {
    margin-left: 0;
  }
`;

ToggleButtonsGroup.StyledButton = StyledButton;

export default ToggleButtonsGroup;
